<template lang="">
  <div>
    <div v-if="!isLoaded" class="h-screen vld-parent">
      <loading :active="!isLoaded" :is-full-page="false" />
    </div>
    <template v-if="isLoaded">
      <div
        class="grid lg:grid-cols-2 lg:space-x-2 md:space-x-0 md:space-y-2 md:grid-cols-1"
      >
        <info-grid
          grid-class="grid-cols-1"
          :title="
            $t(
              'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.headline'
            )
          "
          :data="getProfile()"
        />
        <info-grid
          grid-class="grid-cols-1"
          :title="
            $t(
              'components.marketPlaceManagement.orders.details.marketplace.steps.profile.fleetInfo.headline'
            )
          "
          :data="getFleetData()"
        />
      </div>
    </template>
  </div>
</template>
<script>
import InfoGrid from '@/components/layout/InfoGrid'
import { getFormattedDateTime } from '@/utils/datetime'
import { getAllLockManufacturesData } from '@/services/cache'
export default {
  name: 'ViewMarketplaceProfile',
  components: {
    InfoGrid,
  },
  data() {
    return {
      isLoaded: false,
      profileData: {},
      fallbackText: '--',
      lockManufacturers: [],
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    },
    getMarketplaceDetails() {
      return this.$store.getters['marketplaceDetails/getData']
    },
  },
  async created() {
    this.lockManufacturers = await getAllLockManufacturesData()
  },
  watch: {
    getMarketplaceDetails: {
      deep: true,
      immediate: true,
      handler(updatedData) {
        if (updatedData) {
          console.log('test-w', updatedData)
          this.profileData = updatedData
          this.isLoaded = true
        }
      },
    },
  },
  methods: {
    getFormattedDateTime,
    getLockManufactureName(id) {
      const selectedManufacture = this.lockManufacturers.find(
        (item) => item.id === id
      )
      return selectedManufacture.name
    },
    getProfile() {
      let profile = []
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.marketplaceName'
        ),
        value: this.profileData.brand_name,
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.businessModel'
        ),
        value:
          this.profileData.business_model === 'SH' ? 'Sharing' : 'Store Rental',
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.targetGroup'
        ),
        value: this.profileData.target_group,
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.employeeSize'
        ),
        value: this.profileData.company_employee_size,
      })

      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.lockManufacturerName'
        ),
        value: this.getLockManufactureName(
          this.profileData.lock_manufacturer.id
        ),
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.unitVehiclePrice'
        ),
        value: `${this.profileData.fleet.country.currency_symbol} ${this.profileData.unit_vehicle_price}`,
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.numberOfVehiclesToDeploy'
        ),
        value: this.profileData.number_of_vehicles_to_deploy,
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.numberOfVehiclesSold'
        ),
        value: this.profileData.number_of_vehicles_sold,
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.foundedDate'
        ),
        value: this.getFormattedDateTime(
          this.profileData.year_founded,
          'D MMM, YYYY'
        ),
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.orderStartDate'
        ),
        value: this.getFormattedDateTime(
          this.profileData.order_start_date,
          'D MMM, YYYY'
        ),
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.orderEndDate'
        ),
        value: this.getFormattedDateTime(
          this.profileData.order_end_date,
          'D MMM, YYYY'
        ),
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.operationStartDate'
        ),
        value: this.getFormattedDateTime(
          this.profileData.operation_start_date,
          'D MMM, YYYY'
        ),
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.activationDate'
        ),
        value: this.getFormattedDateTime(
          this.profileData.activation_date,
          'D MMM, YYYY'
        ),
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.rentShare1stYear'
        ),
        value: this.profileData.rent_share_1st_year_by_percentage,
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.rentShare2ndYear'
        ),
        value: this.profileData.rent_share_2nd_year_by_percentage,
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.rentShare3rdYear'
        ),
        value: this.profileData.rent_share_3rd_year_by_percentage,
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.rentShare4thYear'
        ),
        value: this.profileData.rent_share_4th_year_by_percentage,
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.taxInPercentage'
        ),
        value: this.profileData.tax_in_percentage,
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.websiteURL'
        ),
        value: this.profileData.website_url || this.fallbackText,
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.facebookURL'
        ),
        value: this.profileData.facebook_url || this.fallbackText,
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.linkedInURL'
        ),
        value: this.profileData.linkedin_url || this.fallbackText,
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.instagramURL'
        ),
        value: this.profileData.instagram_url || this.fallbackText,
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.youtubeURL'
        ),
        value: this.profileData.youtube_url || this.fallbackText,
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.playstoreURL'
        ),
        value: this.profileData.android_play_store_url || this.fallbackText,
      })
      profile.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.marketplaceInfo.title.appstoreURL'
        ),
        value: this.profileData.ios_app_store_url || this.fallbackText,
      })
      return profile
    },
    getFleetData() {
      let fleet = []
      fleet.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.fleetInfo.title.fleetName'
        ),
        value: this.profileData.fleet.name,
      })
      fleet.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.fleetInfo.title.fleetID'
        ),
        value: this.profileData.fleet.id,
      })
      fleet.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.fleetInfo.title.fleetOrganization'
        ),
        value: this.profileData.fleet.organization.name || this.fallbackText,
      })
      fleet.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.fleetInfo.title.fleetLocation'
        ),
        value: this.profileData.fleet.warehouse_name || this.fallbackText,
      })
      fleet.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.fleetInfo.title.fleetCountry'
        ),
        value: this.profileData.fleet.country.name || this.fallbackText,
      })
      fleet.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.fleetInfo.title.billingPlan'
        ),
        value: this.profileData.fleet.billing_plan || this.fallbackText,
      })
      fleet.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.fleetInfo.title.alertEmailAddress'
        ),
        value: this.profileData.fleet.email_address || this.fallbackText,
      })
      fleet.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.fleetInfo.title.operationalVehicle'
        ),
        value: this.profileData.fleet.operational_vehicle || this.fallbackText,
      })
      fleet.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.fleetInfo.title.createdAt'
        ),
        value: this.getFormattedDateTime(
          this.profileData.fleet.created_at,
          'D MMM, YYYY'
        ),
      })
      fleet.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.fleetInfo.title.fleetVisibility'
        ),
        value: this.profileData.fleet.fleet_visibility || this.fallbackText,
      })
      fleet.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.fleetInfo.title.domain'
        ),
        value: this.profileData.fleet.domain || this.fallbackText,
      })
      fleet.push({
        text: this.$t(
          'components.marketPlaceManagement.orders.details.marketplace.steps.profile.fleetInfo.title.port'
        ),
        value: this.profileData.fleet.port || this.fallbackText,
      })
      return fleet
    },
  },
}
</script>
<style lang=""></style>
